var map = {
	"./cnn-money-x2.png": 2044,
	"./cnn-money.png": 2249,
	"./economist-x2.png": 2045,
	"./economist.png": 2250,
	"./mashable-x2.png": 2046,
	"./mashable.png": 2251,
	"./tech-crunch-x2.png": 2047,
	"./tech-crunch.png": 2252,
	"./thenewyorker-x2.png": 2048,
	"./thenewyorker.png": 2253,
	"./thrillist-x2.png": 2049,
	"./thrillist.png": 2254,
	"./time-x2.png": 2050,
	"./time.png": 2255,
	"./usa-today-x2.png": 2051,
	"./usa-today.png": 2256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2248;